import { render, staticRenderFns } from "./dashTabs.vue?vue&type=template&id=203a118f&scoped=true&"
import script from "./dashTabs.vue?vue&type=script&lang=js&"
export * from "./dashTabs.vue?vue&type=script&lang=js&"
import style0 from "./dashTabs.vue?vue&type=style&index=0&id=203a118f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203a118f",
  null
  
)

export default component.exports